var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeroymerlinAppIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 12,
    fill: "#7BB51C",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5626_454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9667 49.9805H54.8026L35.985 31.0693L16.9667 49.9805Z",
    fill: "#7BB51C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2437 49.0506L19.1915 46.1605L18.2096 45.1485L16.3581 46.9645L13.0966 43.6038L12 44.6789L16.2437 49.0506Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8385 45.5024L22.8589 42.5403L22.0295 41.6863L20.1116 43.5665L19.1907 42.6177L20.7275 41.1108L19.8595 40.2173L18.3227 41.7234L17.5337 40.9107L19.3884 39.0917L18.5595 38.238L15.5486 41.1904L19.8385 45.5024Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7246 31.4596C28.5065 30.2047 26.3934 30.3548 25.3757 31.3528C24.3578 32.3508 23.8383 34.3408 25.2758 35.8216C26.8547 37.4479 28.7332 36.8573 29.7511 35.8598C31.2519 34.3883 30.7176 32.4826 29.7246 31.4596ZM28.8293 35.0004C28.1555 35.6611 27.3318 35.4818 26.3906 34.5121C25.5997 33.6974 25.6472 32.8789 26.2224 32.3149C26.6179 31.927 27.4211 31.5801 28.3767 32.5647C29.467 33.6878 29.5031 34.3397 28.8293 35.0004Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1219 32.5018L34.2362 31.4088L32.5598 29.682L31.5564 25.4863L30.279 26.7391L30.9435 29.1194L28.6985 28.2885L27.494 29.4693L31.3215 30.7045L33.1219 32.5018Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1805 38.334C27.1805 38.334 24.4684 37.404 24.3395 37.4265C24.2977 37.4334 24.9221 35.7637 23.5193 35.0237C23.5193 35.0237 22.4785 34.4575 21.4368 35.4086L19.2166 37.6074L23.4967 41.9393L24.629 40.829L22.313 38.4438L26.0569 39.4357L27.1805 38.334ZM22.9799 37.7392C22.3506 38.3551 22.2657 38.4037 22.2657 38.4037C22.2657 38.4037 21.2792 37.3876 21.2442 37.3516C21.2093 37.3157 21.9497 36.6778 22.0663 36.5633C22.1158 36.5147 22.5768 36.2125 22.9583 36.6053C22.9583 36.6053 23.6089 37.1221 22.9799 37.7392Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7761 26.3131L31.7858 25.3096L36.1092 21L37.5243 22.4336L35.9667 25.5144L39.1422 24.0731L40.5037 25.4529L36.1802 29.7625L35.1367 28.7052L37.4188 26.4306L34.2968 27.8541L33.6514 27.2L35.1025 24.0654L32.7761 26.3131Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.283 33.9195L37.2853 30.8824L41.609 26.5728L44.6152 29.6189L43.7418 30.4896L41.8584 28.5814L41.154 29.2833L42.6395 30.7885L41.73 31.6948L40.2535 30.1986L39.3085 31.1404L41.1742 33.0307L40.283 33.9195Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.168 35.2454L51.2821 36.3746L48.0104 39.6354L49.8406 41.4893L48.7885 42.5386L45.8443 39.5553L50.168 35.2454Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5666 43.3272L53.8903 39.0176L54.9779 40.1193L50.6541 44.4287L49.5666 43.3272Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.6258 46.4274L51.6087 45.3968L55.9327 41.0874L57.4095 42.5828L56.1477 47.0574L59.0097 44.2044L60 45.2079L55.6765 49.5173L54.3852 48.2096L55.4971 43.5122L52.6258 46.4274Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2142 33.2653L45.5881 30.6042L41.2554 34.9051L42.3694 36.0338L44.7316 33.6793L43.8814 37.5659L45.0219 38.7217C45.0219 38.7217 45.9211 35.9415 45.9486 35.8257C45.9486 35.8257 46.9228 36.3651 47.9918 35.4414C47.9918 35.4414 49.0171 34.4374 48.2142 33.2653ZM46.6107 34.5258C46.6107 34.5258 46.0587 34.8982 45.5723 34.4055L44.8125 33.5991C44.8125 33.5991 45.7304 32.684 45.8462 32.5684C45.8462 32.5684 46.5536 33.2854 46.6421 33.3749C46.7303 33.4643 47.288 33.8859 46.6107 34.5258Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5626_454"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 29,
    fill: "white",
    transform: "translate(12 21)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeroymerlinAppIcon);
export default __webpack_public_path__ + "static/media/leroymerlin-app-icon.3d578d599704842163fd4007fa84cc65.svg";
export { ForwardRef as ReactComponent };